import { injectable } from 'inversify';
import 'reflect-metadata';

export interface AbstractFactory<T, E> {
  add(t: T, v: E): void;
  create(t: T, ...a: unknown[]): unknown;
}

@injectable()
export class BaseFactory<T, E> implements AbstractFactory<T, E> {
  map: Map<T, E> = new Map();

  add(type: T, value: E) {
    this.map.set(type, value);
  }

  create(type: T) {
    if (!this.map.has(type)) {
      throw new Error(`Factory ${this.constructor.name}: ${String(type)} is not found!`);
    }

    return this.map.get(type)!;
  }
}
